var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacilityIcon34(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449",
    transform: "translate(-599 -4233)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(599 4233)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_washing_machine",
    d: "M6.785,2A2.806,2.806,0,0,0,4,4.785V27.069a2.806,2.806,0,0,0,2.785,2.785H23.5a2.806,2.806,0,0,0,2.785-2.785V4.785A2.806,2.806,0,0,0,23.5,2Zm0,2.785H23.5V27.069H6.785ZM9.571,6.178a1.393,1.393,0,1,0,1.393,1.393A1.393,1.393,0,0,0,9.571,6.178Zm4.178,0a1.393,1.393,0,1,0,1.393,1.393A1.393,1.393,0,0,0,13.749,6.178Zm1.393,5.571a6.964,6.964,0,1,0,6.964,6.964A6.985,6.985,0,0,0,15.142,11.749Zm0,2.785a4.142,4.142,0,0,1,3.925,2.785h-7.85A4.142,4.142,0,0,1,15.142,14.534Zm-3.925,5.571h7.85a4.158,4.158,0,0,1-7.85,0Z",
    transform: "translate(614 4247)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon34);
export default __webpack_public_path__ + "static/media/facilityIcon34.bf6ce7dcabdf298dff730be662f4a51c.svg";
export { ForwardRef as ReactComponent };